export default "__VITE_ASSET__DC14csb0__"